<template>
  <span>
    <a @click="actionCb(scope)">{{scope.text}}</a>
  </span>
</template>

<script>
export default {
  props: {
    instance: Object,
    scope: Object // text, index, scope
  },
  data() {
    return {

    }
  },
  methods: {
    actionCb(row) {
      const { cb } = this.instance
      this.$emit('actionClick', { row, cb})
    }
  }
}
</script>
